import styled from 'styled-components';
import { withLocalization } from '../shared/Context/LocalizationContext';
import { useLocalization } from '../custom-hooks/useLocalization';
import InsightCard from './cards/InsightCard';
import { device } from '../../utils/styled-component-mixins';
import ServerStylesConditionalWrapper from '../shared/ServerStylesConditionalWrapper';
import NoResultsCard from '../shared/NoResultsCard';

const InsightsLandingWrapperStyled = styled.div`
  .card-grid {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: max-content;
    grid-gap: 1.6rem;
    grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));

    > .widget-spacing-wrapper {
      flex: 0 1 24%;
    }
  }

  .widget-spacing-wrapper {
    margin-bottom: 0;
  }

  .insight-card-wrapper,
  .insight-card {
    height: 100%;
  }

  .insight-card {
    display: flex;
    flex-direction: column;
    height: 100%;

    .animation-wrapper {
      align-items: flex-start;
      flex-direction: column !important;
      justify-content: space-between !important;
      display: flex;
      height: 100%;

      @media ${device.desktop} {
        align-items: flex-start;
        justify-content: flex-end;
      }

      .overflow-wrapper {
        align-self: flex-start;
      }
    }
  }

  .featured-card-content {
    flex: 1 1 auto;
    min-height: 22.4rem;

    @media ${device.desktop} {
      min-height: 31.2rem;
    }
  }

  .overflow-wrapper > a {
    text-decoration: none;
  }

  .cta-wrapper {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 4rem;

    @media ${device.desktop} {
      flex-direction: column;
      margin-top: 0;
    }
  }

  .advanced-search-cta {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 8.3rem;

    @media ${device.desktop} {
      flex-direction: row;
      margin-bottom: 4rem;
      margin-top: 4rem;
    }

    a,
    p {
      font-size: 1.6rem;
      line-height: 2.4rem;
    }

    p {
      margin: 0;

      @media ${device.desktop} {
        margin-bottom: 1px;
        margin-right: 0.8rem;
      }
    }
  }

  .show-more-container {
    display: flex;
    justify-content: center;
    margin-bottom: 4rem;

    @media ${device.desktop} {
      margin: 4rem 0 8rem 0;
    }
  }
  .no-results-card {
    z-index: 1;
  }
`;

export const InsightsLandingComponent = (props) => {
  const { resourceStrings } = useLocalization();
  const readMoreText = resourceStrings.featuredInsightLinkText;
  const noResultsMessage = resourceStrings.insightSectionWidgetNoResults;

  const results = props.insightCards;

  const cardProps = {
    layout: 'standard',
    mediaSide: 'left'
  };

  return (
    <ServerStylesConditionalWrapper>
      <InsightsLandingWrapperStyled>
        <div className="card-grid-wrapper container-padding-md">
          {results.length === 0 ? (
            <div>
              <NoResultsCard className="no-results-card" noResultsMessage={noResultsMessage} />
            </div>
          ) : (
            <div className="card-grid">
              {results.map((item) => (
                <InsightCard
                  key={item.nodeId}
                  cardProps={cardProps}
                  item={{
                    thumbnail: item.image,
                    primaryCategory: item.primaryCategory,
                    pageTitle: item.pageTitle,
                    publishDate: item.publishDate,
                    readMoreText: item.ctaText ? item.ctaText : readMoreText,
                    description: item.description,
                    url: item.url,
                    externalUrl: item.externalUrl,
                    isExternal: item.isExternal
                  }}
                />
              ))}
            </div>
          )}
          <div className="cta-wrapper">
            <div className="advanced-search-cta">
              {props.advancedSearchLinkText && props.advancedSearchLink && (
                <>
                  <p>{props.advancedSearchPrelinkText}</p>
                  <ButtonLink
                    text={props.advancedSearchLinkText}
                    link={props.advancedSearchLink}
                    target="_self"
                    type="tertiary"
                    theme
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </InsightsLandingWrapperStyled>
    </ServerStylesConditionalWrapper>
  );
};

export default withLocalization(InsightsLandingComponent);
